import React from "react";

interface IProps {
	when: boolean;
}

export const Exist: React.FC<IProps> = ({children, when}) => (
	<React.Fragment>{when ? children : null}</React.Fragment>
);
